export default {
  promo: 'Промо'
}
